export {
  NUVO_TAILWIND_CLASS,
  maxHeightOfReviewEntries,
} from '@nuvo-importer/common/sdk';

export const footerHeight = 110;
export const footerMatchBadgeHeight = 28;
export const NUVO_ROOT_ELEMENT = 'nuvo-root-element';
